import type { MarkerWithCircle } from "../components/map/types";

/**
 * Focuses on the preview element of a selected marker after a short delay.
 *
 * This function finds the visible preview element within the selected marker, clicks it,
 * makes it focusable by setting a tabindex attribute, and then sets focus on it.
 * The operation is delayed by 100ms to ensure the DOM is ready.
 *
 * @param selectedMarkerWithPreview - The marker with circle object that contains the marker to focus on
 * @returns {void}
 */
export const focusOnSelectedMarkerPreview = (selectedMarkerWithPreview: MarkerWithCircle): void => {
  const selectedMarkerElement = selectedMarkerWithPreview.marker as HTMLElement;
  // eslint-disable-next-line prefer-const
  let timeout: ReturnType<typeof setTimeout> | undefined;
  clearTimeout(timeout);
  timeout = setTimeout(() => {
    const previewElement: HTMLElement | null = selectedMarkerElement.querySelector(".map-marker-preview.visible .preview-item");
    if (previewElement) {
      previewElement.click();
      previewElement.setAttribute("tabindex", "0");
      previewElement.focus();
    }
  }, 100);
};
